import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `commercial--marketing--sites--testimonials--dashboard`
  }

  doTestimonialsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="commercial--marketing--sites--testimonials--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="commercial--marketing--sites--testimonials--save commercial--marketing--sites--testimonials--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`commercial--marketing--sites--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`commercial--marketing--sites--show--submenu`).dashboardToggleBtn(`DEPOIMENTOS`)

      controller.getControllerByIdentifier(`commercial--marketing--sites--testimonials--index`).permission = `marketing_site_testimonials`
      controller.getControllerByIdentifier(`commercial--marketing--sites--testimonials--show`).permission = `marketing_site_testimonials`
      controller.getControllerByIdentifier(`commercial--marketing--sites--testimonials--save`).permission = `marketing_site_testimonials`

      controller.getControllerByIdentifier(`commercial--marketing--sites--testimonials--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`commercial--marketing--sites--testimonials--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
